<div *ngIf="loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<div class="row ">

  <div class="col-12">
    <div class="card border rounded animated fadeIn fast">
      <div class="card-body animated fadeIn fast">


        <!-- cabecera -->
        <div class="row mb-3">

          <div class="col-6">
            <div class="form-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     (keyup)="buscarTodo($event)" />
            </div>
          </div>

          <div class="col-3">
            <div class=" input-group border border-dark rounded">
              <div class="input-group-addon"><i class="fa-solid fa-warehouse"></i></div>
              <select class="form-control "
                      [(ngModel)]="almSeleccionado"
                      (ngModelChange)="onAlmacenSelect($event)">
                <option value=0>Todos los almacenes</option>
                <option *ngFor="let alm of almacenesList"
                        [value]=alm.id>
                  {{alm.nombre}}
                </option>
              </select>
            </div>
          </div>



          <div class="col-3">
            <form>

              <div class="row float-right">
                <div class="col-sm-6">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="5">5</option>
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group float-right">
                    <div class="btn-group">
                      <button type="button"
                              [routerLink]="'/panel/entrada_edit/new'"
                              class="btn btn-outline-info btn-circle"
                              title="Nuevo">
                        <i class="fa-solid fa-plus"></i>
                      </button>
                      <button type="button"
                              (click)="getListaEntradas()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>
                      <button type="button"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>


            </form>
          </div>

        </div>



        <div class="rounded border">
          <!-- ngx-datatable -->
          <ngx-datatable class="bootstrap datatable-pointer"
                         [style.width]="'100%'"
                         [rows]="rows"
                         [columnMode]="ColumnMode.force"
                         [loadingIndicator]="loading"
                         [headerHeight]="70"
                         [footerHeight]="50"
                         [rowHeight]="50"
                         [limit]="rowsLimit"
                         [rows]='rows'
                         [selected]="selected"
                         [selectionType]="SelectionType.single"
                         (select)="onSelect($event)"
                         [messages]="messages"
                         [footerHeight]="50"
                         [summaryRow]="true"
                         [summaryHeight]="55"
                         [summaryPosition]="summaryPosition">


            <!-- id -->
            <ngx-datatable-column name="id"
                                  prop='id'
                                  [width]="70"
                                  [maxWidth]="70"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <br>
                <div class="header">
                  <h6 class="pointer mt-12">id</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- almNombre -->
            <ngx-datatable-column prop='almNombre'
                                  name="Almacén"
                                  [width]="70"
                                  [maxWidth]="200">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'almNombre')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Almacén</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- cliNombre -->
            <ngx-datatable-column name="cliNombre"
                                  [width]="70"
                                  [maxWidth]="200">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'cliNombre')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Cliente</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- albaran -->
            <ngx-datatable-column name="albaran"
                                  [width]="100"
                                  [maxWidth]="300">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'albaran')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer  link">Albaran</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-rowIndex="rowIndex"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                <span *ngIf="row.swDefectuosos"
                      title="Albarán con artículos defectuosos"
                      class="text-warning ml-12">
                  <i class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i></span>
              </ng-template>
            </ngx-datatable-column>




            <!-- created_at -->
            <ngx-datatable-column name="fecha entrada"
                                  prop="created_at"
                                  [width]="90"
                                  [maxWidth]="120">

              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'created_at')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Entrada</h6>
                </div>
              </ng-template>

              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
              </ng-template>

            </ngx-datatable-column>


            <!-- proveedor -->
            <ngx-datatable-column name="proveedor"
                                  [width]="100"
                                  [maxWidth]="300">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'proveedor')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer  link">Proveedor</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- Origen, devolucion, NO validado,... -->
            <ngx-datatable-column [width]="30"
                                  [sortable]="false">
              <ng-template ngx-datatable-header-template
                           let-column="column">
                <br>
                <div class="header ">
                  <span class="icon-wrapper mt-1">
                    <i class="fa-solid fa-laptop mr-2"
                       title="Creado por el cliente desde su Intranet"></i>
                    <i class="fa-solid fa-check-circle mr-2"
                       title="Entrada NO validada"></i>
                    <i class="fa-solid fa-rotate-left mr-2"
                       title="Entrada por devolución"></i>
                    <i class="fa-solid fa-triangle-exclamation mr-2"
                       title="Entrada con artículos DEFECTUOSOS"></i>
                    <i class="fa-solid fa-mobile-screen mr-2"
                       title="Entrada editable desde una PDA"></i>
                    <i class="fa-solid fa-truck-ramp-box mr-2"
                       title="Entrada DIRECTA Pda"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template let-row="row"
                           ngx-datatable-cell-template>
                <span class="icon-wrapper"
                      title="Creado por el cliente desde su Intranet">
                  <i *ngIf="row.origen === Constantes.ENTRADA_ORIGEN_CLIENTE"
                     class="fa-solid fa-laptop text-secondary"></i>
                </span>
                <span class="icon-wrapper"
                      title="Entrada NO validada">
                  <i *ngIf="row.swValidado !== '2'"
                     class="fa-solid fa-check-circle text-secondary"></i>
                </span>
                <span class="icon-wrapper"
                      title="Entrada por devolución">
                  <i *ngIf="row.devolucion === '1'"
                     class="fa-solid fa-rotate-left text-secondary"></i>
                </span>
                <span class="icon-wrapper"
                      title="Entrada con artículos DEFECTUOSOS">
                  <i *ngIf="row.swDefectuoso === 2"
                     class="fa-solid fa-triangle-exclamation text-secondary"></i>
                </span>
                <span class="icon-wrapper"
                      title="Entrada editable desde una PDA">
                  <i *ngIf="row.swEditPda === '1'"
                     class="fa-solid fa-mobile-screen text-secondary"></i>
                </span>
                <span class="icon-wrapper"
                      title="Entrada DIRECTA Pda">
                  <i *ngIf="row.swEntradaDirecta === '1'"
                     class="fa-solid fa-truck-ramp-box text-secondary"></i>
                </span>

              </ng-template>
            </ngx-datatable-column>



            <!-- username -->
            <ngx-datatable-column name="username"
                                  [width]="100"
                                  [maxWidth]="150">
              <ng-template ngx-datatable-header-template
                           let-sort="
                                              sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'username')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Usuario</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>






            <!-- pales -->
            <ngx-datatable-column name="pales"
                                  [width]="80"
                                  [maxWidth]="100"
                                  [summaryFunc]="sumaCeldas">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'pales')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Palés</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>{{ value }}</ng-template>
            </ngx-datatable-column>


            <!-- líneas -->
            <ngx-datatable-column name="Líneas"
                                  [width]="80"
                                  [maxWidth]="100">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <br>
                <div class="header">
                  <h6 class="pointer mt-12">Líneas</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>{{ row.detall?.length || 0}}</ng-template>
            </ngx-datatable-column>




            <!-- Acciones -->
            <ngx-datatable-column [width]="10"
                                  [sortable]="false">

              <ng-template let-row="row"
                           let-value="value"
                           ngx-datatable-cell-template>

                <div ngbDropdown
                     class="d-inline-block "
                     container="body">

                  <a (click)="infoClickEntrada(row)"
                     class="link mr-1 pointer"
                     title="INFORMACIÓN de esta entrada">
                    <span class="acciones-badge">
                      I
                    </span>
                  </a>

                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          style="border-width: 1px;">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-left">

                    <!-- <a (click)="infoClickEntrada(row)"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="INFORMACIÓN de esta entrada">
                      <i class="fa-solid fa-info-circle"></i> INFORMACIÓN de la entrada
                    </a> -->

                    <a (click)="canValidarEntrada(row) ? editEntrada(row.id) : null"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="VALIDAR entrada"
                       [ngClass]="{'disabled': !canValidarEntrada(row)}">
                      <i class="fa-solid fa-check-circle"></i> VALIDAR entrada
                    </a>

                    <a (click)="canModificarEntrada(row) ? editEntrada(row.id) : null"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="MODIFICAR entrada"
                       [ngClass]="{'disabled': !canModificarEntrada(row)}">
                      <i class="fa-solid fa-edit"></i> MODIFICAR entrada
                    </a>

                    <a (click)="row.pdf_albaran ? abrirPDF(row) : null"
                       class="link mr-2 pointer dropdown-item"
                       placement="top"
                       title="Abrir Pdf del ALBARAN"
                       [ngClass]="{'disabled': !row.pdf_albaran}">
                      <i class="fa-solid fa-file-pdf"></i> Abrir PDF del albarán
                    </a>

                    <a (click)="avisarCliente(row)"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="NOTIFICAR al cliente">
                      <i class="fa-solid fa-envelope"></i> NOTIFICAR al cliente
                    </a>

                    <hr style="margin: 0px;">

                    <a (click)="deleteRow(row)"
                       class="link mr-2 pointer dropdown-item text-danger"
                       placement="top"
                       data-toggle="tooltip"
                       title="Borrar">
                      <i class="fa-regular fa-trash-can fa"></i> Borrar
                    </a>


                  </div>
                </div>

              </ng-template>
            </ngx-datatable-column>





          </ngx-datatable>
        </div>

      </div>
    </div>
  </div>




  <!-- Tabla de detalle de la entrada seleccionada -->
  <div *ngIf="entradasList.length"
       class="col-12">

    <div class="card">
      <div class="card-body">

        <div class="row">

          <div class="col-4">
            <div class="border border-dark rounded p-2">
              <h4 class="card-title">Detalle de la entrada</h4>
              <h6 class="card-subtitle">Líneas pendientes de ubicar</h6>
            </div>
          </div>

          <div class="col-5">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodoPedidos"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodoArticulos"
                     (keyup)="buscarTodoArticulos()" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBuscaArticulos()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-3">
            <span class="me-3">Mostrar artículos ubicados:</span>
            <div class="switch ms-3">
              <label>
                No
                <input type="checkbox"
                       [(ngModel)]="mostrarUbicados"
                       (change)="onToggleMostrarUbicados()">
                <span class="lever"></span>
                Sí
              </label>
            </div>
          </div>

        </div>

        <div class="bootstrap-table">

          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered table-hover">

              <thead>
                <tr>
                  <th>Palé</th>
                  <th></th>
                  <th><i class="fa fa-barcode"></i> Ean</th>
                  <th>Sku</th>
                  <th>Artículo</th>
                  <th>Lote</th>
                  <th style="text-align: center; padding-left: 10px">Cantidad</th>
                  <th colspan="2">Ubicar</th>
                  <th></th>
                </tr>
              </thead>
              <!-- Si hay detall y no está ubicado, mostrarlo -->
              <tbody *ngIf="selected[0]?.detall">
                <ng-container *ngFor="let lin of selected[0].detall; let i = index">

                  <!-- Línea de separación si cambia el palé -->
                  <tr *ngIf="i>0 && lin.pale != selected[0].detall[i-1].pale">
                    <td colspan="10"
                        style="padding: 0; height: 4px; background-color:gray; border: none;">
                    </td>
                  </tr>

                  <!-- Solo los artículos pendientes de ubicar -->
                  <tr *ngIf="lin.id_ubicacion == null">
                    <td [innerHTML]="resaltarTextoArticulos(lin.pale, strBuscarTodoArticulos)"></td>
                    <td>
                      <img [src]="fotoDir +'/articulos' + imgResized + lin.artFoto"
                           loading="lazy"
                           alt="Foto"
                           class="rounded pointer border"
                           height="25px"
                           (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + lin.artFoto)">

                    </td>
                    <td [innerHTML]="resaltarTextoArticulos(lin.artEan, strBuscarTodoArticulos)"></td>
                    <td>
                      <span [innerHTML]="resaltarTextoArticulos(lin.artSku, strBuscarTodoArticulos)"></span>
                      <span *ngIf="lin.swDefectuoso == Constantes.DEFECTUOSO">
                        <i title="Defectuoso"
                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                      </span>
                    </td>
                    <td [innerHTML]="resaltarTextoArticulos(lin.artDescripcion, strBuscarTodoArticulos)"></td>
                    <td [innerHTML]="resaltarTextoArticulos(lin.lote, strBuscarTodoArticulos)"></td>
                    <td style="text-align: right; padding-left: 10px">
                      <div class="pl-25 mr-20 monospace"
                           [innerHTML]="resaltarTextoArticulos((lin.cantidad | number: '0.0-0':'es'), strBuscarTodoArticulos)">
                      </div>
                    </td>
                    <td>
                      <!-- está validado? Ubicar artículo -->
                      <span *ngIf="selected[0].swValidado ==='2'">
                        <!-- No se puede ubicar artículo en entradas directas -->
                        <span *ngIf="selected[0].swEntradaDirecta !== '1'">
                          <a href="javascript: void(0);"
                             [routerLink]="'/panel/entrada_ubicar_articulo/' + selected[0].id + '/' + lin.id"
                             title="Ubicar artículos">
                            <i class="fa-solid fa-box-open"></i>
                          </a>
                        </span>
                      </span>
                    </td>

                    <td>
                      <!-- está validado? Ubicar palé completo -->
                      <span *ngIf="selected[0].swValidado ==='2'">
                        <!-- No se puede ubicar palé completo en entradas directas -->
                        <span *ngIf="selected[0].swEntradaDirecta !== '1'">
                          <span *ngIf="i == 0 || lin.pale != selected[0].detall[i-1].pale">
                            <a href="javascript: void(0);"
                               (click)="ubicarPaleCompleto(selected[0].id, lin.pale)"
                               title="Ubicar palé completo">
                              <i class="fa-solid fa-dolly"></i>
                            </a>
                          </span>
                        </span>
                      </span>
                    </td>
                    <td>
                      <a (click)="eanLabelsSrv.imprimirEanLabel(lin.id_articulo!)"
                         class="link mr-1 pointer"
                         title="Generar etiquetas EAN">
                        <span class="acciones-badge">E</span>
                      </a>
                    </td>
                  </tr>

                  <!--Info sobre los ya ubicados -->
                  <tr *ngIf="lin.id_ubicacion !== null && mostrarUbicados"
                      class="linea-ubicada">
                    <td [innerHTML]="resaltarTextoArticulos(lin.pale, strBuscarTodoArticulos)"></td>
                    <td>
                      <img [src]="fotoDir +'/articulos' + imgResized + lin.artFoto"
                           loading="lazy"
                           alt="Foto"
                           class="rounded pointer border"
                           height="25px"
                           (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + lin.artFoto)">

                    </td>
                    <td [innerHTML]="resaltarTextoArticulos(lin.artEan, strBuscarTodoArticulos)"></td>
                    <td>
                      <span [innerHTML]="resaltarTextoArticulos(lin.artSku, strBuscarTodoArticulos)"></span>
                      <span *ngIf="lin.swDefectuoso == Constantes.DEFECTUOSO">
                        <i title="Defectuoso"
                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                      </span>
                    </td>
                    <td [innerHTML]="resaltarTextoArticulos(lin.artDescripcion, strBuscarTodoArticulos)"></td>
                    <td [innerHTML]="resaltarTextoArticulos(lin.lote, strBuscarTodoArticulos)"></td>
                    <td style="text-align: right; padding-left: 10px">
                      <div class="pl-25 mr-20 monospace"
                           [innerHTML]="resaltarTextoArticulos((lin.cantidad | number: '0.0-0':'es'), strBuscarTodoArticulos)">
                      </div>
                    </td>
                    <td colspan="2"
                        title={{funcLib.CodUbiDecript(lin.ubicacion)}}>
                      <!-- Ubicación -->
                      <!-- <span class="ml-3 ubiCod monospace text-secondary"
                            [innerHTML]="resaltarTextoArticulos((lin.ubicacion | mask: '00.00.00.00.00.00'), strBuscarTodoArticulos)"></span> -->
                      <div class="ml-3 ubiCod monospace"
                           title="{{funcLib.CodUbiDecript(lin.ubicacion)}}"
                           [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(lin.ubicacion), strBuscarTodoArticulos | mask: '00.00.00.00.00.00')"></div>
                    </td>
                    <td>
                      <a (click)="eanLabelsSrv.imprimirEanLabel(lin.id_articulo!)"
                         class="link mr-1 pointer"
                         title="Generar etiquetas EAN">
                        <span class="acciones-badge">E</span>
                      </a>
                    </td>
                  </tr>

                </ng-container>
              </tbody>

              <!-- Añadir pie de tabla con totales -->
              <tfoot *ngIf="selected[0]?.detall">
                <tr class="font-weight-bold bg-light">
                  <td>Total PENDIENTES de ubicar:</td>
                  <td class="text-right"> {{ getCountLineasPendientes() }} líneas</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{ getTotalCantidad() | number: '0.0-0':'es' }}
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>

            </table>
          </div>

        </div>
      </div>

      <div class="clearfix"></div>
    </div>

  </div>


</div>



<!-- Modal para mostrar la imagen -->
<div class="modal-overlay"
     *ngIf="imagenSeleccionada"
     (click)="cerrarPopupImagen()">
  <div class="modal-content">
    <img [src]="imagenSeleccionada"
         class="modal-image"
         alt="Imagen seleccionada">
  </div>
</div>